import { useNavigate } from "react-router-dom";
import { FaTimes, FaTag, FaSearch, FaLightbulb, FaQuoteLeft } from "react-icons/fa";
import CommonModal from "./CommonModal";
import { useState } from "react";

// 디자인 시스템 임포트
import { designTokens, commonStyles } from "utils/designSystem";
import { detailModalStyles } from "utils/modalDesignSystem";

const BrandNameDetail = ({ item, setModal }) => {
  const [alert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const navigate = useNavigate();

  if (!item) return null; // item이 없을 경우 아무것도 렌더링하지 않음

  // 스타일 정의
  const modalStyles = {
    overlay: detailModalStyles.overlay,
    container: {
      backgroundColor: designTokens.colors.surface,
      borderRadius: designTokens.borderRadius.xl,
      boxShadow: designTokens.shadows.lg,
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    header: {
      ...commonStyles.card,
      padding: designTokens.spacing.xxl,
      borderBottom: `1px solid ${designTokens.colors.border}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: designTokens.colors.surface,
      borderRadius: `${designTokens.borderRadius.xl} ${designTokens.borderRadius.xl} 0 0`,
      marginBottom: 0
    },
    title: detailModalStyles.title,
    closeButton: {
      ...commonStyles.buttonBase,
      padding: designTokens.spacing.md,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      color: designTokens.colors.text.tertiary,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      ':hover': {
        backgroundColor: designTokens.colors.background,
        color: designTokens.colors.text.primary
      }
    },
    content: detailModalStyles.content,
    keywordSection: {
      ...commonStyles.card,
      padding: designTokens.spacing.xxl,
      marginBottom: designTokens.spacing.xxl,
      backgroundColor: designTokens.colors.primary + '08',
      border: `1px solid ${designTokens.colors.primary}30`
    },
    keywordTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.md,
      fontSize: '16px',
      fontWeight: '600',
      color: designTokens.colors.text.primary,
      marginBottom: designTokens.spacing.lg
    },
    keywordContent: {
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.md,
      fontSize: '18px',
      fontWeight: '700',
      color: designTokens.colors.primary,
      padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
      backgroundColor: designTokens.colors.surface,
      borderRadius: designTokens.borderRadius.lg,
      border: `2px solid ${designTokens.colors.primary}30`
    },
    resultsSection: {
      ...commonStyles.card,
      padding: designTokens.spacing.xxl
    },
    resultsTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.md,
      fontSize: '16px',
      fontWeight: '600',
      color: designTokens.colors.text.primary,
      marginBottom: designTokens.spacing.xxl
    },
    resultsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: designTokens.spacing.xxl
    },
    nameItem: {
      ...commonStyles.card,
      padding: designTokens.spacing.xxl,
      backgroundColor: designTokens.colors.surface,
      border: `1px solid ${designTokens.colors.border}`,
      borderRadius: designTokens.borderRadius.lg,
      transition: 'all 0.2s ease',
      cursor: 'default',
      ':hover': {
        borderColor: designTokens.colors.primary,
        boxShadow: designTokens.shadows.md
      }
    },
    nameTop: {
      fontSize: '20px',
      fontWeight: '700',
      color: designTokens.colors.text.primary,
      marginBottom: designTokens.spacing.md,
      textAlign: 'center',
      padding: `${designTokens.spacing.lg} 0`,
      borderBottom: `2px solid ${designTokens.colors.primary}`,
      position: 'relative'
    },
    nameMeaning: {
      fontSize: '14px',
      color: designTokens.colors.text.secondary,
      lineHeight: '1.6',
      padding: designTokens.spacing.md,
      backgroundColor: designTokens.colors.background,
      borderRadius: designTokens.borderRadius.md,
      border: `1px solid ${designTokens.colors.borderLight}`,
      position: 'relative',
      marginTop: designTokens.spacing.lg
    },
    meaningIcon: {
      position: 'absolute',
      top: designTokens.spacing.sm,
      left: designTokens.spacing.sm,
      color: designTokens.colors.text.tertiary
    },
    meaningText: {
      paddingLeft: designTokens.spacing.xxl
    }
  };

  return (
    <>
      <div style={modalStyles.overlay}>
        <div style={modalStyles.container} onClick={(e) => e.stopPropagation()}>
          {/* 헤더 */}
          <div style={modalStyles.header}>
            <h2 style={modalStyles.title}>
              <FaTag />
              브랜드 네이밍 생성 결과
            </h2>
            <button
              style={modalStyles.closeButton}
              onClick={() => setModal(false)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = designTokens.colors.background;
                e.target.style.color = designTokens.colors.text.primary;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = designTokens.colors.text.tertiary;
              }}
            >
              <FaTimes size={16} />
            </button>
          </div>

          {/* 컨텐츠 */}
          <div style={modalStyles.content}>
            {/* 검색 키워드 섹션 */}
            <div style={modalStyles.keywordSection}>
              <div style={modalStyles.keywordTitle}>
                <FaSearch />
                검색 키워드
              </div>
              <div style={modalStyles.keywordContent}>
                <FaQuoteLeft size={14} />
                {item.input_text}
              </div>
            </div>

            {/* 생성 결과 섹션 */}
            <div style={modalStyles.resultsSection}>
              <div style={modalStyles.resultsTitle}>
                <FaLightbulb />
                생성된 브랜드명 및 의미
              </div>
              
              <div style={modalStyles.resultsGrid}>
                {item.generated_name
                  ?.split(",")
                  .map((name, index) => {
                    const createdName = name.trim();
                    const meaningList =
                      item.generated_meaning?.split("|").map((m) => m.trim()) ?? [];

                    return (
                      <div key={index} style={modalStyles.nameItem}>
                        <div style={modalStyles.nameTop}>
                          {createdName}
                        </div>
                        {meaningList[index] && (
                          <div style={modalStyles.nameMeaning}>
                            <FaLightbulb 
                              size={12} 
                              style={modalStyles.meaningIcon}
                            />
                            <div style={modalStyles.meaningText}>
                              {meaningList[index]}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
          }}
        />
      )}
    </>
  );
};

export default BrandNameDetail;